<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" class=" text-capitalize font-weight-bold" color="primary">+ Add</v-btn>
      </template>
      <v-card class="pa-3" color="pop_bg">
        <v-row>
          <v-card-title class="dark--text text-h6 mt-n2 ms-2">Add Category Type</v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-row>
        <v-divider></v-divider>

        <v-card-text>
          <v-container class="mt-2">
            <h3 class="ms-sm-8 dark--text text-body-1 font-weight-bold">
              Enter Meal Category Details
            </h3>
            <v-form class="pa-sm-8" @submit="createCategory()" v-model="valid" ref="form">
              <v-layout wrap>
                <v-flex xs12 sm3 md2>
                  <h5 class="text-body-2 dark--text mt-4 mt-sm-0">
                    Category Name
                  </h5>
                </v-flex>
                <v-flex xs10 sm6 md4>
                  <v-text-field label="Category Type Name" v-model="nameEn" :rules="[requiredValidator('category type name')]" solo dense></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm3 md2>
                  <h5 class="text-body-2 dark--text">
                    Category Type Name (Arabic)
                  </h5>
                </v-flex>
                <v-flex xs10 sm6 md4>
                  <v-text-field v-model="nameAr" label="Category Name Arabic" :rules="[requiredValidator('category type name in arabic')]" solo dense></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs6 sm3 md2 class="me-md-3">
                  <h5 class="text-body-2 dark--text">Currently Active</h5>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-radio-group v-model="active" :mandatory="false" row>
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm3 md2>
                  <h5 class="text-body-2 dark--text">Show Order</h5>
                </v-flex>
                <v-flex xs10 sm6 md4 class="mt-3 mt-md-0">
                  <v-text-field :rules="[requiredValidator('order')]" solo dense label="Show Order" type="number" v-model="showOrder" @keypress="isNumber" min="0"></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex>
                  <h5 class="text-body-2 dark--text">Select icon</h5>
                </v-flex>
                <v-flex>
                  <v-img :src="this.selectedIcon" max-width="30" height="30"> </v-img>
                </v-flex>
                <v-flex>
                  <categoryIcons @updateIcon="updateIcon"></categoryIcons>
                </v-flex>
              </v-layout>
              <v-layout row justify-end class="mt-5 mb-sm-n10">
                <v-btn :width="$vuetify.breakpoint.smAndUp ? 120 : 90" color="primary" class=" text-capitalize" @click="createCategory()" :loading="btnloading" :disabled="!valid">Save</v-btn>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">{{ text }}</v-snackbar>
  </div>
</template>

<script>
import { requiredValidator } from "../../core/methods/validations";
import categoryIcons from "../components/CategoryIcons.vue";
export default {
  components: {
    categoryIcons,
  },

  data() {
    return {
      requiredValidator: requiredValidator,
      nameEn: "",
      nameAr: "",
      active: true,
      showOrder: "",
      btnloading: false,
      valid: true,
      errors: [],
      snackbar: false,
      text: "",
      show_dialog_box: false,
      pcValueNotRequired: false,
      selectedIcon: "",
      categoryTypes: [],
      categoryType: null,
    };
  },
  methods: {
    updateIcon(icon) {
      this.selectedIcon = icon;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    createCategory() {
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("@/menu-packages/api/createCategoryType.graphql"),
          variables: {
            nameEn: this.nameEn,
            nameAr: this.nameAr,
            showOrder: parseInt(this.showOrder),
            active: this.active,
            icon: this.selectedIcon,
          },
          update: (store, { data: { createCategoryType } }) => {
            try {
              const query = {
                query: require("@/menu-packages/api/getAllCategoryTypes.graphql"),
              };

              let allCategories = store.readQuery(query);
              allCategories.getAllCategoryTypes.unshift(createCategoryType); //push to top
              store.writeQuery({
                ...query,
                data: allCategories,
              });
              this.text = "Category Type Added";
              this.snackbar = true;
              this.show_dialog_box = false;
            } catch (e) {
              // console.log(e);
              console.log("Something bad happend- CategoryForm.vue");
            }
            this.$refs.form.reset();
            this.btnloading = false;
          },
        })
        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
        });
    },
    close() {
      this.show_dialog_box = false;
    },
  },
};
</script>
